var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.182 0.125H1.81797C1.5017 0.125413 1.1985 0.251234 0.974869 0.474869C0.751234 0.698505 0.625413 1.0017 0.625 1.31797V12.682C0.625413 12.9983 0.751234 13.3015 0.974869 13.5251C1.1985 13.7488 1.5017 13.8746 1.81797 13.875H13.182C13.4983 13.8746 13.8015 13.7488 14.0251 13.5251C14.2488 13.3015 14.3746 12.9983 14.375 12.682V1.31797C14.3746 1.0017 14.2488 0.698505 14.0251 0.474869C13.8015 0.251234 13.4983 0.125413 13.182 0.125ZM13.125 12.625H1.875V1.375H13.125V12.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/EndCall.05b684761e82dc2be7fa4af0fec25569.svg";
export { ForwardRef as ReactComponent };